import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {getCmsList} from "../../api/service.js"

export default{
    components:{
        myHeader,
        myFooter
    },
    data(){
        return{
            tabSelect:"0",
            activeName:"全部",
            generalNewsList:[],
            headlineNewsList:[],
            newsList:[],
            newsCategory:null,
            newsTotal:0,
            pageSize:10,
            pageNum:1,
            Purl:"",
            tabsList:[
                {title:"全部"},
                {title:"站内新闻"},
                {title:"行业资讯"}
            ],
        }
    },
    created(){
        this.pUrl=window.location.href.substring(0,window.location.href.indexOf("/",7));

        this.getNewsSlidshow()
        this.getNewsInformationList()
    },
    methods:{
        //切换tab页获取对应对应的下标
        handleClick(tab, event) {
            if(tab.index!=0){
                this.newsCategory=tab.index
            }else{
                this.newsCategory=null
            }
            this.getNewsInformationList()
        },
        //获取新闻资讯轮播图
        getNewsSlidshow(){
            let url="news/getNewsSlidshow"
            getCmsList(url).then(res=>{
                if(res.code==0){
                    this.generalNewsList=res.data.generalNewsList
                    this.headlineNewsList=res.data.headlineNewsList
                }
            })
        },
        //根据分类获取新闻
        getNewsInformationList(){
            let url='news/getNewsInformationList'
            let data={
                pageNum:this.pageNum,
                pageSize:this.pageSize,
                newsCategory:this.newsCategory
            }
            getCmsList(url,data).then(res=>{
                if(res.code==0){ 
                    for(var i=0;i<res.data.length;i++){
                        var item=res.data[i]
                        let month=item.newsReleaseTime.split("-")[1]
                        let day=item.newsReleaseTime.split("-")[2].split(" ")[0]
                        item.month=month
                        item.day=day
                        // console.log(888,item.newsReleaseTime.split("-"))
                    }
                    this.newsList=res.data
                    this.newsTotal=res.total
                }
            })
        },
        currentChange(page){
            this.pageNum=page
            this.getNewsInformationList()
        },
        GotoNewsDetail(id){
            this.$router.push({
                path:"/newsDetail",
                query:{ 
                    newsId:id,
                }
              });
        },
    }
}



// WEBPACK FOOTER //
// ./src/pages/tutorial/tutorial.js